import { reduce, split } from 'lodash'

export const getCookie = (name: string) => {
  const cookies = split(document.cookie, '; ')

  return reduce(
    cookies,
    (r, v) => {
      const parts = split(v, '=')
      return parts[0] === name ? decodeURIComponent(parts[1]) : r
    },
    ''
  )
}

export const getAuthToken = () => {
  const auth = getCookie('RZONE_AUTH_TOKEN')

  if (!auth) {
    return []
  }

  const parsedAuth: { authToken: string } = JSON.parse(auth)

  return parsedAuth.authToken
}
